module.exports = __webpack_public_path__ + "style/img/AI_P_1.6062add2.png";